<template>
  <div class="t-container page">
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Damage Claim
      </h1>
      <div class="t-flex t-mx-auto t-my-2">
        <button
          @click="formShown = true"
          class="t-align-right t-bg-dodger-blue t-px-8 t-py-3"
        >
          <span class="t-text-base t-font-bold t-text-white">
            <span class="t-text-sm">+</span>
            Create Claim
          </span>
        </button>
      </div>
    </div>

    <div class="t-flex t-items-center t-justify-center t-mt-5">
      <div class="t-flex t-flex-col t-space-y-8 lg:t-w-18/20 lg:t-mr-8">
        <section
          class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white"
        >
          <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
            <h3 class="t-text-xl t-font-bold">
              {{ bookingNumber }}
            </h3>
          </div>

          <div class="t-w-full t-min-w-lg t-mt-4">
            <loading-alert
              text="Fetching claims"
              v-if="loading"
            ></loading-alert>

            <table
              class="t-w-full t-text-md bg-white t-rounded t-mb-4"
              v-else-if="claims.length > 0 && !loading"
            >
              <tbody>
                <tr class="t-border-b">
                  <th class="t-text-left t-p-3 t-px-5">Claim</th>
                  <th class="t-text-left t-p-3 t-px-5">Files</th>
                </tr>
                <damage-claims-item
                  :claim="claim"
                  v-for="claim in claims"
                  :key="claim.id"
                >
                </damage-claims-item>
              </tbody>
            </table>

            <div
              class="t-bg-gray-100 t-border t-border-gray-400 t-text-gray-700 t-px-4 t-py-3 t-rounded t-relative"
              v-else
            >
              No damage claims to show
            </div>
          </div>
          <damage-claims-form
            v-if="formShown"
            :showing="formShown"
            :booking-id="bookingId"
            :booking-number="bookingNumber"
            @cancelled="formShown = false"
            @submitted="submitted"
          >
          </damage-claims-form>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import DamageClaimsItem from "./DamageClaimsItem";
import DamageClaimsForm from "./DamageClaimsForm";
import LoadingAlert from "../../utils/LoadingAlert";

export default {
  name: "damage-claims",
  components: { DamageClaimsItem, DamageClaimsForm, LoadingAlert },
  props: ["bookingId", "bookingNumber"],

  data() {
    return {
      claims: [],
      formShown: false,
      loading: false
    };
  },

  mounted() {
    this.fetchDamageClaims();
  },

  methods: {
    submitted() {
      this.formShown = false;
      this.fetchDamageClaims();
    },

    fetchDamageClaims() {
      this.loading = true;

      axios
        .get("/send-freight/bookings/" + this.bookingId + "/damage-claims", {
          headers: { Accept: "application/json" }
        })
        .then(response => {
          this.claims = response.data.data;
          this.loading = false;
        })
        .catch(errors => {
          this.loading = false;
          Event.$emit("serverError");
        });
    }
  }
};
</script>
